/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Faq_7_AInputs */

const en_vc_faq_7_a = /** @type {(inputs: Vc_Faq_7_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inkscape is mature, stable and built around SVG. VectorCraft is much younger but copies Illustrator's layout, tools and shortcuts, renders faster on the GPU and can be controlled by AI agents. If you are coming from Illustrator, VectorCraft will feel more familiar. If you need proven stability today, Inkscape is the safer choice.`)
};

const zh_vc_faq_7_a = /** @type {(inputs: Vc_Faq_7_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inkscape 成熟稳定，以 SVG 为核心。VectorCraft 年轻得多，但照搬了 Illustrator 的布局、工具和快捷键，GPU 渲染更快，还能被 AI 助手操控。如果你是从 Illustrator 转过来的，VectorCraft 会更顺手；如果现在就需要久经考验的稳定性，Inkscape 更稳妥。`)
};

/**
* | output |
* | --- |
* | "Inkscape is mature, stable and built around SVG. VectorCraft is much younger but copies Illustrator's layout, tools and shortcuts, renders faster on the GPU ..." |
*
* @param {Vc_Faq_7_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_faq_7_a = /** @type {((inputs?: Vc_Faq_7_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Faq_7_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_faq_7_a(inputs)
	return zh_vc_faq_7_a(inputs)
});
export { vc_faq_7_a as "vc.faq.7.a" }